import { Card, CardBody } from "reactstrap";
import { ImagesAssets } from "../../Component/shared/ImageAssets";
import { Image } from "../../AbstractElements";

type WithImageShadowCardProps = {
  name?: string;
  id?: string;
  role?: string;
  email?: string;
  phone?: string;
  EmployeeMedia?:any
};

const WithImageShadowCard: React.FC<WithImageShadowCardProps> = ({
  EmployeeMedia,
  name,
  id,
  role,
  email,
  phone,
}) => {

  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  return (
    <Card
      className="text-center p-1  rounded-3 shadow-sm"
      style={{ minWidth: "265px", height: "260px", width: "100%" }}
    >
      <CardBody>
        <Image
          style={{width:'100px',height:'100px', borderRadius:'50px'}}
          className="tab-img"
          // src={ImagesAssets?.CardImages}
          src={EmployeeMedia ? `${BASE_URL}${EmployeeMedia}`
              : "https://via.placeholder.com/100?text=No+Image"}
          alt="profile"
        />

        <h6 className="mt-2 mb-1 text-primary" style={{ color: "#318fd4" }}>
          {name} ({id})
        </h6> 
        <p className="mb-1 text-muted" style={{ fontSize: "13px",fontWeight:'600' }}>
          {role}
        </p>
        <p className="mb-1 text-secondary" style={{ letterSpacing: 0 }}>
          {email}
        </p>
        <p className="mb-0 text-dark">{phone}</p>
      </CardBody>
    </Card>
  );
};

export default WithImageShadowCard;
